class r extends Error{constructor(r){super(r)}}export{r as default};
